/**
 * Developed by Spell Solutions for Trivinci Systems, LLC.
 *
 * Developer attribution only. Ownership, licensing, and permitted use are
 * governed by the applicable agreement and applicable law.
 */
// Entry point for index.html — boots the SPA shell.
import { publishVersion } from "./lib/version";
import "./components/rk-app";

publishVersion();
